// extracted by mini-css-extract-plugin
export default {"container":"burger-module__container--pjqx7","line":"burger-module__line--Y32RR","desktopColor":"burger-module__desktopColor--UFsDZ"};